import React from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import img from "../../../Assets/img/Path 2.svg";
import img2 from "../../../Assets/img/Group 10.svg";
import object2 from "../../../Assets/img/OBJECTS (2).svg";

import process from "../../../Assets/img/process_section.PNG";
import process_mobile from "../../../Assets/img/process_mobile.png";
import list1 from "../../../Assets/img/problem_solve.svg";
import list2 from "../../../Assets/img/google_searching.svg";
import list3 from "../../../Assets/img/image_reverse.svg";
import list4 from "../../../Assets/img/logical.svg";
import autoattend from "../../../Assets/img/auto_attend_logo.png";
import hastag from "../../../Assets/img/logo_hastag.png";
import PuzzlerTalk from "../../Components/LandingPage/PuzzlerTalk";
function About() {
  return (
    <div className="about innerBody">
    <Header />
    <div className="intro py-lg-9 position-relative text-white">      
      <div className="pt-5 pt-md-11">
        <div className="container pt-3">
          <h3 className="title ml-auto mr-auto text-center">ABOUT</h3>
          <div className="row align-items-center">
            <div className="col-12 col-md-12 col-lg-7 order-md-2">
              <img
                src={img2}
                className="img-fluid mw-md-150 mw-lg-130 mb-6 mb-md-0"
                alt="..."
              />
            </div>
            <div className="col-lg-5 col-md-12 col-12">
              <h2 className="title text-light">
                <span> WHO ARE WE?</span> 
              </h2>
              <p className="mt-3">
              Puzzled has been conceptualized and created by a team of puzzling enthusiasts, who have literally cracked every online puzzling event in the past decade. The passion for puzzling led us to create something to give back to the immensely fluttery puzzling community. Our success in this venture gets closer to fulfillment every time you feel the pride in solving each level we have designed for you!
              </p>
            </div>
          </div>
        </div>
      </div>     
    </div>
     

        <div className="process_img d-xl-block d-lg-block d-md-block d-sm-none d-none">
          <img src={process} alt="" />
        </div>

        <div className="process_img d-xl-none d-lg-none d-md-none d-sm-block d-block">
          <img src={process_mobile} alt="" />
        </div>

        <div className="container how-to pt-5 pb-5">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-12">
              <h3 className="mb-4">How to play</h3>
          <h4 className="mb-0">Attention to Detail</h4>
          <p>
            Clearly observe and study every element in each level. Everything is there for a reason. 
          </p>

          <h4 className="mb-0 pt-3">Google is your Best Friend</h4>
          <p>
            Google is always a good idea. Make sure you look up any clues, as this will often help you get closer to the answer.
          </p>
          <h4 className="mb-0 pt-3">Crack the Level</h4>
          <p>
            There is no limit on the number of attempts. So keep guessing and keep solving.
          </p>

          <h4 className="mb-0 pt-3">Hall of Fame</h4>
          <p>
            Complete all levels and get on to our coveted Hall of Fame. 
          </p>
         </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-12">
              <img src={object2} className="left-object" alt="" />
            </div>
          </div>
        </div>

        <div className="container-fluid bg-base">
          <div className="container">
            <div className="row">
              <div className="col pl-0 pr-0">
                <div className="card card-body border-0 o-hidden mb-0 text-light signup_now">
                  <div className="position-relative flex-column flex-md-row align-items-center">
                    <div className="h3 text-center mb-md-0">
                      <span>Are you up for the challenge ?</span> Sign up now and
                      start cracking!  <a href="/register" className="btn btn-lg btn-yellow ml-5">
                      REGISTER
                    </a>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="skill-Area">
          <div className="container pt-5 pb-5">
            <div className="row justify-content-center text-center mb-6">
              <div className="col-xl-8 col-lg-9">
                <h2 className="display-4 mx-xl-6">SKILLS REQUIRED</h2>
              </div>
            </div>
            <div className="row text-center skills_required">
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list1} alt="" /> <br/>
                <span> Problem <br/> Solving </span> 
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list2} alt="" /> <br/>
                <span> Google <br/> Searching </span>
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list3} alt="" /> <br/>
                <span> Image Reverse <br/> Search </span>
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list4} alt="" /> <br/>
                <span> Logical <br/> Reasoning </span>
              </div>
            </div>
          </div>
        </section>
        <div className="section-bottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-12 pt-5">
                <h3>Want to get your brain cells ready?</h3>
                <p>
                  If you want to have a crack at something close to the real game, do play our Warm Up game. It will gear you up for the main event!
                </p>
                <div className="text-left"> <a href="/editions" className="btn btn-yellow">PLAY WARM UP</a>  </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-powered-by pt-4 pb-4">
          <div className="container">
            <div className="row text-center">
              <h3 className="ml-auto mr-auto">POWERED BY</h3>
            </div>
            <div className="row mt-3">
              <div className="col-lg-6 col-md-12 col-12 pb-4">
                <h4>They make us run this game</h4>
                <p>
                  The generous contributions of our corporate sponsors give us the ability to do so much more. These businesses and organizations find value in our work and support us. If you would like to sponsor, do get in touch. 
                </p>
                
                <div className="text-left sponsor_buttons">
                 <a href="/become-sponsor" className="btn btn-yellow mt-3"> BECOME A SPONSOR </a>
                  
                 <a href="/private-puzzled" className="btn btn-yellow mt-3 ml-4" style={{padding:"7PX 28PX"}}>  HOST AN EVENT </a> 
                </div> 


              </div>
              <div className="col-lg-6 col-md-12 col-12 powered_by pb-4">
                <div className="container">         
                 <div className="row">
                  <div className="col-4 offset-2">
                    <a href="https://autoattend.com/" target={"_blank"} rel="noopener noreferrer"> <img src={autoattend} alt="" /> </a>
                  </div>
                  <div className="col-4">
                    <a href="https://www.hashtagtechnologies.com/" target={"_blank"} rel="noopener noreferrer"> <img src={hastag} alt="" /> </a>
                  </div>
                </div>  
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <PuzzlerTalk />
        <Footer />
  </div>
  );
}

export default About;